import {useStore} from '@/store/root-store';
import {observer} from 'mobx-react-lite';
import styled from 'styled-components';
import {FocusTermsTabs} from './FocusTermsAndQuestions/FocusTermsTabs';
import {HeaderSection} from './HeaderSection';
import {TermsAssistantRightSidebar} from './TermsAssistant/RightSidebar';
import {TopRankingCompetitors} from './TopRankingCompetitors/TopRankingCompetitors';
import {DrawersTriggers} from './DrawersTriggers';
import {useState} from 'react';

interface Props {
  changeView: () => void;
}

export const Analytics = observer(({changeView}: Props) => {
  const {contentOptimizer: {currentPage}} = useStore('');
  const [viewSuggestionsOption, setViewSuggestionsOption] = useState(false);
  const [linksDropDownFromSuggestion, setLinksDropDownFromSuggestion] = useState<'links' | 'terms'>('links');

  return <Wrapper>
    {!currentPage?.isLinkActive && <HeaderSection setLinksDropDownFromSuggestion={setLinksDropDownFromSuggestion} setViewSuggestionsOption={setViewSuggestionsOption}/>}
    {currentPage?.isTaActive ? <TermsAssistantRightSidebar /> : currentPage?.isLinkActive ? '' : <ContentContainer>
      <DrawersTriggers changeView={changeView}/>
      <FocusTermsTabs linksDropDownFromSuggestion={linksDropDownFromSuggestion} viewSuggestionsOption={viewSuggestionsOption}/>
      {!currentPage.focusTermsExpanded ? <TopRankingCompetitors /> : null}
    </ContentContainer>}
  </Wrapper>;
});

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;
const ContentContainer = styled.div`
  overflow-y: auto;
  height: 100%;
  padding-right: 5px;

  // For Internet Explorer
  scrollbar-face-color: rgba(138,138,138,0.32);
  scrollbar-track-color: rgba(138,138,138,0.12);

  // For Google Chrome
  &::-webkit-scrollbar {
    height: 5px;
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: #E8E8E8;
  }

  &::-webkit-scrollbar-track {
    background: rgba(138,138,138,0.12);
  }
`;


